import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Permission } from 'src/app/constants/permission.constant';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-view-mode-action',
  templateUrl: './view-mode-action.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ViewModeActionComponent {
  @Input() postView = 'selects';
  @Output() postViewChange = new EventEmitter<string>();

  Permission = Permission;

  constructor(public authService: AuthService) {}

  onViewChange(value: string): void {
    this.postViewChange.emit(value);
  }
}
